'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormattedTimeAgo = function (_PureComponent) {
  _inherits(FormattedTimeAgo, _PureComponent);

  function FormattedTimeAgo() {
    _classCallCheck(this, FormattedTimeAgo);

    return _possibleConstructorReturn(this, (FormattedTimeAgo.__proto__ || Object.getPrototypeOf(FormattedTimeAgo)).apply(this, arguments));
  }

  _createClass(FormattedTimeAgo, [{
    key: 'render',
    value: function render() {
      var localTime = _moment2.default.utc(this.props.time).local();
      var localTimeString = localTime.calendar(null, {
        sameDay: function sameDay() {
          return '[' + localTime.fromNow() + ']';
        },
        nextDay: 'MMMM Do [at] LT',
        nextWeek: 'MMMM Do [at] LT',
        lastDay: '[yesterday]',
        lastWeek: 'MMMM Do [at] LT',
        sameElse: function sameElse(now) {
          if (now.year() !== this.year()) {
            return 'MMMM Do, YYYY';
          }
          return 'MMMM Do [at] LT';
        }
      });

      // Moment doesn't guarantee that text like "yesterday" will be capitalized
      localTimeString = localTimeString.charAt(0).toUpperCase() + localTimeString.slice(1);

      return _react2.default.createElement(
        'span',
        { className: this.props.className },
        localTimeString
      );
    }
  }]);

  return FormattedTimeAgo;
}(_react.PureComponent);

FormattedTimeAgo.propTypes = {
  className: _react.PropTypes.string,
  time: _react.PropTypes.string.isRequired
};
exports.default = FormattedTimeAgo;